import { patchWithJSON } from "./RequestService";
import { decamelizeKeys } from "utils/formatters";

export const wageDebtorProfileURL = debtorID => `/wage_debtors/${debtorID}`;

export function updateWageDebtorRequest(debtor) {
  const url = wageDebtorProfileURL(debtor.id);
  const payload = { wage_debtor: decamelizeKeys(debtor) };

  return patchWithJSON(url, payload);
}
